import { useRegisterSW } from 'virtual:pwa-register/react';
import { useEffect, useState } from 'react';

const UPDATE_CHECK_INTERVAL_MS = 30 * 60 * 1000;
// Si el SW nuevo no emite `controlling` (ya no hay waiting, otra pestaña lo activó, etc.),
// updateServiceWorker(true) no recarga nunca: forzamos el reload tras este plazo.
const FORCE_RELOAD_DELAY_MS = 2000;

export function UpdateToast() {
  const [registration, setRegistration] = useState<ServiceWorkerRegistration>();
  const { needRefresh: [needRefresh, setNeedRefresh], updateServiceWorker } = useRegisterSW({
    onRegisteredSW(_swUrl, serviceWorkerRegistration) {
      if (serviceWorkerRegistration) setRegistration(serviceWorkerRegistration);
    },
  });

  useEffect(() => {
    if (!registration) return;

    const intervalId = window.setInterval(() => {
      void registration.update();
    }, UPDATE_CHECK_INTERVAL_MS);

    return () => window.clearInterval(intervalId);
  }, [registration]);

  const handleUpdate = () => {
    void Promise.resolve(updateServiceWorker(true)).catch(() => undefined);
    window.setTimeout(() => window.location.reload(), FORCE_RELOAD_DELAY_MS);
  };

  if (!needRefresh) return null;

  return (
    <div style={{ position: 'fixed', bottom: 16, left: 16, zIndex: 9999 }}>
      <div
        role="status"
        aria-live="polite"
        style={{
          background: 'var(--color-toast-bg)',
          color: 'var(--color-toast-text)',
          borderRadius: 10,
          padding: '12px 16px',
          boxShadow: '0 4px 16px rgba(0,0,0,0.2)',
          minWidth: 280,
          maxWidth: 360,
          display: 'flex',
          alignItems: 'center',
          gap: 12,
        }}
      >
        <p style={{ margin: 0, flex: 1, fontSize: 13, fontWeight: 600 }}>
          Hay una nueva versión disponible
        </p>
        <button
          onClick={handleUpdate}
          style={{
            background: 'var(--color-toast-action-bg)',
            color: 'var(--color-surface)',
            border: 'none',
            borderRadius: 6,
            padding: '6px 12px',
            fontSize: 12,
            cursor: 'pointer',
            flexShrink: 0,
            fontWeight: 500,
          }}
        >
          Actualizar
        </button>
        <button
          onClick={() => setNeedRefresh(false)}
          style={{
            background: 'none',
            border: 'none',
            color: 'var(--color-toast-close)',
            cursor: 'pointer',
            padding: '4px 8px',
            fontSize: 12,
            flexShrink: 0,
          }}
        >
          Después
        </button>
      </div>
    </div>
  );
}
